import { useEffect } from 'react'

/**
 * This hook automatically revokes object URLs when they change or when the component unmounts.
 * This prevents memory leaks from accumulating blob URLs created with URL.createObjectURL().
 * @param url - The URL to clean up. If it starts with 'blob:', it will be revoked on change or unmount.
 * @example
 * const [photoPath, setPhotoPath] = useState<string | null>(null)
 * useObjectUrlCleanup(photoPath)
 * // The object URL will be automatically revoked when photoPath changes or component unmounts
 */
const useObjectUrlCleanup = (url: string | null) => {
  useEffect(() => {
    if (url && url.startsWith('blob:')) {
      return () => URL.revokeObjectURL(url)
    }
    return undefined
  }, [url])
}

export default useObjectUrlCleanup
